import { Status } from '@Components/Base';

import { useGetTenderQuery } from '@Features/MaterialRequest/requests/TenderRequest/store/api/TenderRequestApiSlice';
import { useMemo } from 'react';
import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import styles from './tender-info.module.css';
import { tenderInfoFieldSource } from '../../../View/FieldSource';

const TenderInfo: React.FC<{ tenderId: string }> = ({ tenderId }) => {
  const { data } = useGetTenderQuery(tenderId!, {
    skip: !tenderId,
    refetchOnMountOrArgChange: true,
  });

  const fieldSource = useMemo(
    () =>
      data
        ? [
            ...tenderInfoFieldSource({
              data,
            }),
          ]
        : [],
    [data]
  );

  if (!data) return null;

  return (
    <div className={styles.container}>
      {fieldSource.map((item) => (
        <div className={styles.viewItem} key={item.label}>
          <span>{item.label}</span>
          {item.label === 'Status' ? (
            <Status
              className={styles.viewItemValue}
              text={String(item.value) || ''}
            />
          ) : (
            <span className={styles.viewItemValue}>
              {item.value || EMPTY_FIELD_PLACEHOLDER}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default TenderInfo;
